import React from 'react';
import styles from './Gutter.module.scss';

const Gutter: React.FC<{ half?: boolean }> = ({ half }) => {
  return <div className={half ? styles.halfGutter : styles.gutter}></div>;
};

export default Gutter;
